export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/databases.fb9bb2a.svg";